import React, { ReactNode } from "react";
import timeImage from "../../assets/image1.png";
import clickImage from "../../assets/image3.png";
import diffImage from "../../assets/image2.png";
import Text from "../../../../components/ui/Text";
import { Difficulty } from "../../types";
import { DIFFICULTY_CONFIG } from "../../constants/difficulty";

interface StatCardProps {
  label: string;
  value: ReactNode;
  iconImage: string;
  className?: string;
  imgClassName?: string;
}

const StatCard = React.memo(function StatCard({
  label,
  value,
  iconImage,
  className = "",
  imgClassName = "",
}: StatCardProps) {
  return (
    <div
      className={`rounded-[7px] drop-shadow-sm pl-0 p-3 h-[50px] relative flex items-center overflow-hidden ${className}`}
    >
      <img
        src={iconImage}
        alt="icon"
        className={`max-w-[37px] max-h-[37px] object-contain mr-1 ${imgClassName}`}
      />
      <Text
        size="md"
        className="uppercase text-white bebas-neue-font !font-semibold mr-1 whitespace-nowrap"
      >
        {label}
      </Text>

      <div className="bg-gradient-to-r from-white/10 to-white/5 px-3 py-1 min-w-[50px] flex items-center justify-center text-center h-[30px] rounded-md ml-auto">
        <Text className="gilroy-font text-white" size="xxs">
          {value}
        </Text>
      </div>
    </div>
  );
});

interface ElectricianGameProgressProps {
  timeLeft: number;
  clicks: number;
  difficulty: Difficulty;
  className?: string;
}

// Format seconds as mm:ss
function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m > 0 ? `${m}:${String(s).padStart(2, "0")}` : `${s}s`;
}

function ElectricianGameProgress({
  timeLeft,
  clicks,
  difficulty,
  className = "",
}: ElectricianGameProgressProps) {
  // Colour timer card red when under 10 s
  const timeCardBg =
    timeLeft <= 10
      ? "bg-gradient-to-r from-[#6b1212] to-[#4a1010]"
      : "bg-gradient-to-r from-[#125a2a] to-[#174025]";

  return (
    <div
      className={`flex items-start justify-between space-x-3 w-full ${className}`}
    >
      {/* Time Left */}
      <StatCard
        label="Time Left"
        value={formatTime(timeLeft)}
        iconImage={timeImage}
        className={`flex-1 ${timeCardBg} min-w-[160px] transition-colors duration-500`}
      />

      {/* Clicks */}
      <StatCard
        label="Clicks"
        value={`${clicks}`}
        iconImage={clickImage}
        className="flex-[1] bg-gradient-to-r from-[#58186b] to-[#442249] min-w-[160px]"
      />

      {/* Difficulty — currently disabled
      <StatCard
        label="Difficulty"
        value={
          <span
            style={{ color: DIFFICULTY_CONFIG[difficulty].color }}
            className="font-bold"
          >
            {DIFFICULTY_CONFIG[difficulty].label}
          </span>
        }
        iconImage={diffImage}
        className="flex-1 bg-gradient-to-r from-[#144966] to-[#15354a] min-w-[160px]"
      />
      */}
    </div>
  );
}

export default React.memo(ElectricianGameProgress);
